import React from 'react';
import LegalPageLayout from '../components/LegalPageLayout';

const Privacy = () => (
  <LegalPageLayout title="Privacy Policy" lastUpdated="August 2026">
    <p>
      WE R GAME (&quot;we&quot;, &quot;us&quot;, &quot;our&quot;) operates a sports information markets and fan gaming
      platform with FREE, BOOST, and MARKET play modes. This Privacy Policy explains how we collect, use, and protect
      your information when you use our website and services.
    </p>

    <h2>Information we collect</h2>
    <ul>
      <li>
        <strong>Account data:</strong> username, email, phone (if verified), password hash, and profile settings.
      </li>
      <li>
        <strong>Wallet data:</strong> linked wallet addresses used for Boost, Market trading, jackpot claims, and gas
        drips. We do not store private keys.
      </li>
      <li>
        <strong>Activity data:</strong> predictions, tickets, streaks, leaderboard stats, orderbook trades, positions,
        and transaction history on our platform and, where applicable, on-chain.
      </li>
      <li>
        <strong>Technical data:</strong> IP address, browser type, device information, and usage logs for security and
        abuse prevention.
      </li>
      <li>
        <strong>Communications:</strong> support messages and newsletter subscriptions if you opt in.
      </li>
    </ul>

    <h2>How we use your information</h2>
    <ul>
      <li>Provide and operate Free, Boost, and Market features across tournaments and cups.</li>
      <li>Verify eligibility, prevent fraud, enforce limits, and maintain platform integrity.</li>
      <li>Calculate jackpots, payouts, points, streaks, and leaderboard rankings.</li>
      <li>Send service emails (verification codes, security notices) and optional marketing if you subscribe.</li>
      <li>Improve the product, debug issues, and comply with legal obligations.</li>
    </ul>

    <h2>Blockchain and public data</h2>
    <p>
      Market and jackpot transactions may be recorded on Base. Blockchain data is public and immutable. Your linked
      wallet address and on-chain activity may be visible to anyone. We link that activity to your account only when you
      connect or verify a wallet with us.
    </p>

    <h2>Advertising</h2>
    <p>
      We use Google AdSense to show advertisements on selected pages (Free details and Blogs). Google and its partners
      may use cookies and similar technologies to serve and measure ads. See{' '}
      <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer">
        Google Privacy Policy
      </a>{' '}
      and{' '}
      <a href="https://policies.google.com/technologies/ads" target="_blank" rel="noopener noreferrer">
        how Google uses information from sites that use ads
      </a>
      .
    </p>

    <h2>Sharing</h2>
    <p>We do not sell your personal data. We may share information with:</p>
    <ul>
      <li>Infrastructure providers (hosting, email, analytics) under confidentiality obligations.</li>
      <li>Law enforcement or regulators when required by law or to protect users and the platform.</li>
      <li>Service partners strictly necessary to operate payments, relayers, or chain interactions.</li>
    </ul>

    <h2>Retention and security</h2>
    <p>
      We retain account and activity data while your account is active and as needed for legal, audit, and dispute
      purposes. We use industry-standard measures to protect data; no system is 100% secure.
    </p>

    <h2>Your choices</h2>
    <ul>
      <li>Update profile details in your account settings.</li>
      <li>Unsubscribe from marketing emails via the link in any newsletter.</li>
      <li>Request account deletion by contacting support — some records may be retained where required by law.</li>
    </ul>

    <h2>Children</h2>
    <p>
      WE R GAME is not intended for users under 18 (or the legal age in your jurisdiction). We do not knowingly collect
      data from minors.
    </p>

    <h2>Contact</h2>
    <p>
      For privacy questions, contact us through the support channels listed on the platform or via the email provided in
      your account region settings.
    </p>
  </LegalPageLayout>
);

export default Privacy;
